import React from 'react'

const WorkItems = ({item}) => {
  return (
    <div className="work__card" key={item.id}>
        <h3 className="work__title">{item.title}</h3>
        <span className="work__subtitle">{item.subtitle}</span>
        
        {/* Tech Stack Section */}
        {item.techStack && (
          <div className="work__tech-stack">
            <div className="work__tech-title">Tech stack</div>
            <div className="work__tech-pills">
              {item.techStack.map((tech, index) => (
                <span key={index} className="work__tech-pill">
                  {tech}
                </span>
              ))}
            </div>
          </div>
        )}
        
        <br />
        { item && item.link && (
        <a href={item.link} className="work__button">
            Demo <i className="bx bx-right-arrow-alt work__button-icon"></i>
        </a>
        )}
        { item && item.repo && (
          <a href={item.repo} className="work__button">
            Repository <i className="bx bx-right-arrow-alt work__button-icon"></i>
          </a>
        )}
    </div>
  )
}

export default WorkItems